
        <div class="vs-menu-group-heading" *ngIf="selectedGroup">
            <i [ngClass]="selectedGroup.icon || 'fa-light fa-folder'" aria-hidden="true"></i>
            <span>{{selectedGroup.ten}}</span>
        </div>
        <ul app-submenu [item]="filteredModel" [level]="0" root="true" class="vs-main-menu layout-menu layout-main-menu clearfix"
            [menuGroupCode]="selectedGroup ? selectedGroup.ma : null"
            [pinnedMenuIds]="pinnedMenuIds" (onTogglePin)="togglePin($event)" [reset]="reset" visible="true" parentActive="true"></ul>
        <ul (mouseover)="mouseOverPinnedMenu()" (mouseleave)="mouseLeavePinnedMenu()"
            class="vs-pinned-menu show" [class.show]="showPinnedMenu && pinnedMenuData && pinnedMenuData.length">
            <li class="pinned" *ngFor="let item of pinnedMenuData;let i = index" [authorize]="item.phanQuyen"
                                [isNavigationPermission]="true"
                                [permissionType]="permissionType">
                <i class="fa-light fa-thumb-tack pinned-icon" (click)="unpinMenuItem(item.id)" title="Bỏ ghim"></i>
                <a class="ripplelink" [routerLink]="item.routerLink" routerLinkActive="active-menuitem-routerlink"
                   [routerLinkActiveOptions]="{exact: true}">
                    <div class="decoration">
                        <i class="fa-light fa-cube decorated-icon"></i>
                    </div>
                    <span class="menuitem-label">{{item.label}}</span>
                </a>
            </li>
        </ul>
    